<template>
  <div class="product-price" :class="productPriceClasses">
    <template v-if="$props.price">
    <span v-if="$props.months" class="recurring">
      {{ $props.months }}x
    </span>
      {{ $props.price }} <span class="currency">{{ $props.currency || $t('common.currency') }}</span>
    </template>
    <span v-else class="no-price"> - </span>
  </div>
</template>

<script>
export default {
  name: 'product-price',
  props: {
    months: [String, Number],
    price: [String, Number],
    currency: String,
    size: {
      type: String,
      default: 'normal',
      validator: value => {
        return ['normal', 'md', 'lg'].includes(value)
      }
    }
  },
  computed: {
    productPriceClasses () {
      return {
        [`size-${this.$props.size}`]: this.$props.size
      }
    }
  }
}
</script>

<style scoped lang="scss">
.product-price {
  font-size: 2rem;
  font-weight: 600;
  color: $primary;

  .no-price {
    color: $text;
  }

  .recurring, .currency {
    font-size: 1.4rem;
    color: $text;
  }

  .recurring {
    display: inline-block;
    min-width: 2.6rem;
  }

  &.size-md {
    font-size: 1.6rem;

    .recurring, .currency {
      font-size: 1.4rem;
    }

    @media (map_get($breakpoints, sm)) {
      font-size: 2rem;

      .recurring, .currency {
        font-size: 2rem;
      }
    }
  }

  &.size-lg {
    font-size: 2rem;

    .recurring, .currency {
      font-size: 1.6rem;
    }

    @media (map_get($breakpoints, sm)) {
      font-size: 2.4rem;

      .recurring, .currency {
        font-size: 2rem;
      }
    }
  }
}
</style>
